import zwitCore from "./config/http";
// const BASE_URL = "/apis";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
    // 商品课程列表
    getJypxList(params) {
        return zwitCore.HTTP.postJsonData(BASE_URL + "/zw-information/articleCurriculum/goodsPageList", params, false);
    },
    // 商品会议列表
    getSphyList(params) {
        return zwitCore.HTTP.postJsonData(BASE_URL + "/zw-goods/goods/nf/selectAllMeeting", params, false);
    },
    // 可选投稿期刊列表
    getManuscriptList(params) {
        return zwitCore.HTTP.get(BASE_URL + "/tsg-author/web/per/contributeList", params, false);
    },
    // 我的收藏-行业报告列表
    getReportCollectList(params) {
        return zwitCore.HTTP.get(BASE_URL + "/zw-goods/goodsCollect/nf/getUserIndustryReportCollectList", params, false);
    },
    // 发布机构列表
    selectReport(params) {
        return zwitCore.HTTP.get(BASE_URL + "/zw-goods/shops/selectReport", params, false);
    },
};
